import React, { useEffect } from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import {
  useDataModel,
  params,
  arrayOf as arrayType,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';
import { getStoreLayoutLink, ready } from '../helper';
import './aisle-bay-find-most.scss';

export const AisleBayFindMost = ({ itemId, products, store }) => {
  const { storeId, storeName } = store;
  const storeSkuIds = products.map((product) => product.identifiers?.storeSkuNumber)
    .filter((sku) => !!sku);

  const shouldSkip = !(products?.length && store?.storeId && storeSkuIds?.length);
  const aisleBayResponse = useDataModel('aislebay', {
    skip: shouldSkip,
    ssr: false,
    variables: {
      storeId,
      storeSkuIds,
    }
  });

  useEffect(() => {
    ready('aisle-bay-find-most');
  });

  const { aislebay } = aisleBayResponse.data || {};
  const { storeSkus } = aislebay || {};

  if (!products?.length || !storeSkus?.length) {
    return null;
  }

  const counts = {};
  let mostCommonAisle = { count: 0, aisle: null };
  storeSkus.forEach((sku) => {
    const { aisleBayInfo } = sku;
    const { aisle, bay } = aisleBayInfo || {};
    if (!(aisle && bay)) {
      return;
    }
    counts[aisle] = counts[aisle] ? counts[aisle] + 1 : 1;
    mostCommonAisle = counts[aisle] > mostCommonAisle.count
      ? { ...aisleBayInfo, count: counts[aisle] }
      : mostCommonAisle;
  });
  // added so this component does not render undefined or blank aisle
  if (!mostCommonAisle.aisle) {
    return null;
  }

  return (
    <a className="aisle-bay-find-most" href={getStoreLayoutLink({ aislebay: mostCommonAisle, itemId, store })}>
      <Image asset="poi-outline.svg" alt="Location Pin" />
      <div className="aisle-bay-find-most__text">
        <span>Find most of these in&nbsp;
          <span className="aisle-bay-find-most__text--bold">
            Aisle {mostCommonAisle.aisle} at { storeName } Store
          </span>
        </span>
        <span className="aisle-bay-find-most__text--primary">Tap to see on store map</span>
      </div>
      <Image asset="next-arrow-orange.svg" alt="Arrow Right" />
    </a>
  );

};

AisleBayFindMost.displayName = 'AisleBayFindMost';

AisleBayFindMost.propTypes = {
  itemId: string,
  products: arrayOf(shape({})).isRequired,
  store: shape({
    storeId: string,
    storeName: string
  }).isRequired
};

AisleBayFindMost.dataModel = {
  aislebay: params({
    storeId: stringType().isRequired(),
    storeSkuIds: arrayType(stringType().isRequired())
  }).shape({
    storeSkus: arrayType(shapeType({
      storeNumber: stringType(),
      storeSkuId: stringType(),
      aisleBayInfo: shapeType({
        aisle: stringType(),
        bay: stringType(),
        invLocDesc: stringType()
      })
    }))
  }),
};

AisleBayFindMost.defaultProps = {
  itemId: null
};
